import GeoZoneIcon from './component'

export default GeoZoneIcon
